var map = {
	"./BETANO.png": "5aff",
	"./BETFAIR.png": "fd85",
	"./BETFIRST.png": "e1b6",
	"./BETMGM_COLORADO.png": "5b91",
	"./BETR.png": "652a",
	"./BETSSON.png": "a22b",
	"./BETVICTOR.png": "485d",
	"./BET_188.png": "80fe",
	"./BET_365.png": "24a1",
	"./BWIN.png": "e48f",
	"./DRAFTKINGS.png": "99b7",
	"./ESPN.png": "295f",
	"./FANDUEL.png": "8320",
	"./FONBET.png": "411a",
	"./HUDDLE.png": "dac0",
	"./INSTABET.png": "8561",
	"./LADBROKES.png": "f6d3",
	"./MARATHON_BET.png": "16ec",
	"./ONE_XBET.png": "c8c1",
	"./PADDY_POWER.png": "f191",
	"./PINNACLE.png": "3862",
	"./RIVALRY.png": "1bf8",
	"./SBO.png": "492c",
	"./SKY_BET.png": "8d27d",
	"./SPORTRADAR.png": "4a95",
	"./SUPERBET.png": "5f03",
	"./TIPICO.png": "7534",
	"./TIPWIN.png": "3556",
	"./UNIBET.png": "54bc",
	"./WILLIAMHILL.png": "a947",
	"./WILLIAM_HILL.png": "737d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fe1e";